import React from 'react';
import { Grid, SxProps, TextField, Theme, Typography } from '@mui/material';
import InputMask from 'react-input-mask';
import useWindowSize from '../../../hooks/useWindowSize';
import { FormikErrors, FormikTouched } from 'formik';

interface FieldItem {
  name: string;
  label: string;
  type: string;
}

interface Props {
  fields: FieldItem[];
  values: Record<string, any>;
  errors: FormikErrors<any>;
  touched: FormikTouched<any>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: any) => void;
  sx?: SxProps<Theme>; 
  sxMask?: SxProps<Theme>; 
}

export const TextFieldsGrid: React.FC<Props> = ({
  fields,
  values,
  handleChange,
  touched,
  errors,
  sx,
  sxMask
}) => {
  const { width } = useWindowSize();

  const getMask = (name: string): string | null => {
    if (name === 'cnpj') return '99.999.999/9999-99';
    if (name === 'cep') return '99999-999';
    if (name === 'number') return '(99) 99999-9999';
    return null;
  };

  return (
    <Grid
      container
      spacing={2}
      textAlign="center"
      justifyContent="space-around"
      paddingX={width > 600 ? 10 : 2}
      mb={4}
    >
      {fields.map((field) => {
        const mask = getMask(field.name);
        const error = Boolean(touched[field.name] && errors[field.name]);
        const helperText =
          touched[field.name] && typeof errors[field.name] === 'string'
            ? (errors[field.name] as string)
            : undefined;

        return (
          <Grid item xs={12} sm={6} md={4} key={field.name}>
            <Typography style={{whiteSpace: 'nowrap',}} variant="body1">{field.label}</Typography>
            {mask ? (
              <InputMask
                mask={mask}
                value={values[field.name] || ''}
                onChange={handleChange}
              >
                {(inputProps: any) => (
                  <TextField
                    {...inputProps}
                    name={field.name}
                    fullWidth
                    placeholder={field.label}
                    error={error}
                    helperText={helperText}
                    FormHelperTextProps={{
                      sx: {
                        fontSize: '1rem',
                      }
                    }}
                    sx={sxMask}

                  />
                )}
              </InputMask>
            ) : (
              <TextField
                name={field.name}
                placeholder={field.label}
                type={field.type}
                value={values[field.name] || ''}
                fullWidth
                onChange={handleChange}
                error={error}
                helperText={helperText}
                sx={sx}
                FormHelperTextProps={{
                  sx: {
                    fontSize: '1rem',
                  }
                }}
              />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};